(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('event-field-definition', {
            parent: 'entity',
            url: '/event-field-definition?page&sort',
            data: {
                authenticate: true,
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Dictionnaire des champs événement'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/event-field-definition/event-field-definitions.html',
                    controller: 'EventFieldDefinitionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'fieldCode,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('event-field-definition.new', {
            parent: 'event-field-definition',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$state', '$uibModal', function($state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-field-definition/event-field-definition-dialog.html',
                    controller: 'EventFieldDefinitionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fieldCode: null,
                                label: null,
                                dataType: 'text',
                                valuePossibleJson: '[]',
                                constraintsJson: '{}',
                                validationsJson: '[]',
                                exampleValuesJson: '[]',
                                requiredByDefault: false,
                                hiddenForEncoder: false,
                                active: true,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('event-field-definition', null, { reload: true });
                }, function() {
                    $state.go('event-field-definition');
                });
            }]
        })
        .state('event-field-definition.edit', {
            parent: 'event-field-definition',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-field-definition/event-field-definition-dialog.html',
                    controller: 'EventFieldDefinitionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EventFieldDefinition', function(EventFieldDefinition) {
                            return EventFieldDefinition.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-field-definition', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
